"use client";

import React from "react";
import { ShieldCheck, Truck, Calculator, FileText } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const advantagesData = [{
  title: "Stock Permanente",
  description: "Contamos con un inventario constante de equipos y licencias para asegurar que su implementación tecnológica nunca se detenga por falta de suministros.",
  icon: ShieldCheck
}, {
  title: "Entrega en Todo el País",
  description: "Llegamos a cada rincón del territorio nacional con logística eficiente, garantizando que sus soluciones de comunicación lleguen a tiempo y seguras.",
  icon: Truck
}, {
  title: "Cotizamos a la Medida",
  description: "Analizamos sus necesidades específicas de infraestructura y flujo de llamadas para ofrecerle un presupuesto optimizado que se ajuste a su realidad.",
  icon: Calculator
}, {
  title: "Mejoramos Cotizaciones",
  description: "Presente su propuesta por escrito y nos comprometemos a mejorar las condiciones comerciales, asegurando la mejor relación costo-beneficio del mercado.",
  icon: FileText
}];
function AdvantageCard({
  data,
  index
}: {
  data: (typeof advantagesData)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDelay: `${index * 100}ms`
  }}>
      <Card className="h-full border-l-4 border-l-primary border-t-border border-r-border border-b-border shadow-md hover:shadow-lg transition-shadow duration-300 bg-card">
        <CardContent className="p-6 flex flex-col sm:flex-row items-start gap-5 h-full">
          <div className="shrink-0 p-3 bg-primary/10 rounded-lg text-primary">
            <data.icon className="w-6 h-6" strokeWidth={1.5} />
          </div>
          <div className="flex flex-col gap-2">
            <h3 className="text-xl font-bold font-default text-foreground">
              {data.title}
            </h3>
            <p className="text-lg font-sans text-muted-foreground leading-relaxed">
              {data.description}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>;
}
export default function GarantAsYBeneficios() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255597" id="garantías-y-beneficios" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground">
            Nuestras Garantías y Beneficios
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {advantagesData.map((adv, i) => <AdvantageCard key={i} data={adv} index={i} />)}
        </div>
      </div>
    </section>;
}